import { Box, Fade } from "@material-ui/core";
import React from "react";

export default function MainBox(props) {
  return (
    <Fade in timeout={850}>
      <Box
        style={{
          margin: "55px auto 0",
        }}
        className="MainBoxENGH"
      >
        {props.children}
      </Box>
    </Fade>
  );
}
